import {merge} from 'lodash';
import {getAllRateLimits, getRateLimitById} from '../api/rateLimitsThunk';

/* eslint-disable no-param-reassign */
const {createSlice} = require('@reduxjs/toolkit');

const initialState = {
    allRateLimits: [],
    rateLimit: null,
    status: {
        loading: false,
        error: false
    },
    error: null
};

const setPendingState = (state) => {
    state.error = null;
    const status = {
        loading: true,
        error: false
    };
    state.status = merge(state.status, status);
};

const setRejectedState = (state, action) => {
    const status = {
        loading: false,
        error: true
    };
    state.status = merge(state.status, status);
    state.error = action.error.message;
};

const setGetFulfilledState = (state) => {
    const status = {
        loading: false,
        error: false
    };
    state.error = null;
    state.status = merge(state.status, status);
};

const rateLimitSlice = createSlice({
    name: 'rateLimitSlice',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllRateLimits.fulfilled, (state, action) => {
                setGetFulfilledState(state);
                state.allRateLimits = action.payload;
            })
            .addCase(getRateLimitById.fulfilled, (state, action) => {
                setGetFulfilledState(state);
                state.rateLimit = action.payload;
            })
            .addMatcher((action) => action.type.endsWith('/pending') && action.type.includes('rateLimits/'), (state) => {
                setPendingState(state);
            })
            .addMatcher((action) => action.type.endsWith('/rejected') && action.type.includes('rateLimits/'), (state, action) => {
                setRejectedState(state, action);
            });
    }
});

export default rateLimitSlice.reducer;
